import React from 'react';
import './Home.css';

export const Home: React.FC<{}> = () => {
  return <p className="home">homepage</p>;
};
